export const businessInfo = {
  name: "HimCream Naturals",
  tagline: "Naturally Delicious. Made Fresh in Udaipur.",
  subTagline: "Udaipur ka Natural Ice Cream • 100% Real Fruits & Real Milk",
  description:
    "HimCream Naturals brings handcrafted artisanal natural ice creams, thick shakes, rich rabdi, and royal faludas to Udaipur. Made with 100% real fresh seasonal fruits and pure milk — free from artificial flavors, synthetic colors, and chemical preservatives.",
  
  owner: "Lalit Choudhary",

  address: {
    street: "Sec 4, Mali Colony Road",
    area: "Sector 4",
    city: "Udaipur",
    state: "Rajasthan",
    pincode: "313001",
    country: "India",
    full: "Sec 4, Mali Colony Road, Udaipur, Rajasthan 313001",
  },

  contact: {
    phone: "+919549607055",
    phoneDisplay: "+91 95496 07055",
    whatsapp: "+919549607055",
    email: "parshwebcraft@gmail.com",
    instagram: "himcream.naturals",
    instagramUrl: "https://instagram.com/himcream.naturals",
    mapsUrl: "https://maps.app.goo.gl/DJUQ15qwD1nSZKR87",
    mapsEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62515.49050478117!2d73.63729814863282!3d24.5730187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967efc7f68747d3%3A0x585c52bed61da177!2sHimCream%20Naturale's!5e1!3m2!1sen!2sin!4v1788084826318!5m2!1sen!2sin",
  },

  timings: {
    days: "Monday – Sunday (All 7 Days)",
    hours: "11:00 AM – 11:30 PM",
    isOpen: true,
  },

  features: [
    {
      title: "100% Real Fruits",
      desc: "Fresh Alphonso Mangoes, handpicked Strawberries, Sitaphal, and seasonal local fruits.",
      icon: "Apple",
    },
    {
      title: "Pure Buffalo & Cow Milk",
      desc: "Rich, creamy whole milk sourced daily from local dairy farms in Rajasthan.",
      icon: "Milk",
    },
    {
      title: "Zero Artificial Flavors",
      desc: "No synthetic colors, no artificial essences, and no chemical stabilisers.",
      icon: "Sparkles",
    },
    {
      title: "Freshly Made in Udaipur",
      desc: "Crafted in small batches daily to retain natural aroma, smooth texture, and real taste.",
      icon: "Heart",
    },
  ],

  stats: [
    { label: "Real Flavours", value: "20+" },
    { label: "Fresh Milk Sourced", value: "100%" },
    { label: "Natural Ingredients", value: "100%" },
    { label: "Happy Customers", value: "15,000+" },
  ],
};
